import { Metadata } from 'next';
import logoImg from '@public/logo.png';
import { LAYOUT_OPTIONS } from '@/config/enums';
import logoIconImg from '@public/logo-short.svg';
import { OpenGraph } from 'next/dist/lib/metadata/types/opengraph-types';

enum MODE {
  DARK = 'dark',
  LIGHT = 'light',
}

export const siteConfig = {
  title: 'Cresivox - ',
  description: `Cresivox`,
  logo: logoImg,
  icon: logoIconImg,
  mode: MODE.LIGHT,
  layout: LAYOUT_OPTIONS.HYDROGEN,
  // TODO: favicon
};

export const metaObject = (
  title?: string,
  openGraph?: OpenGraph,
  description: string = siteConfig.description
): Metadata => {
  return {
    title: title ? `${title} - Cresivox` : siteConfig.title,
    description,
    openGraph: openGraph ?? {
      title: title ? `${title} - Cresivox` : title,
      description,
      url: 'admin.cresivox.com',
      siteName: 'Cresivox', // https://developers.google.com/search/docs/appearance/site-names
      images: {
        url: 'https://oneclickdocs.s3.ap-south-1.amazonaws.com/product%5Bimages%5D%5B5%5D%5Burl%5D-1754996223350-WhatsAppImage2025-08-12at11.06.29AM.jpeg',
        width: 1200,
        height: 630,
      },
      locale: 'en_US',
      type: 'website',
    },
  };
};
